import {
  DEADLINE_BG_COLOR_DEFAULT,
  DEADLINE_TEXT_COLOR_DEFAULT,
} from '../../../constants/date'
import { getEntityDeadlineStatusColorByDate } from '../../Entity'

export function getColorProperties(deadline, done) {
  if (done) {
    return {
      backgroundColor: DEADLINE_BG_COLOR_DEFAULT,
      textColor: DEADLINE_TEXT_COLOR_DEFAULT,
    }
  }

  return getEntityDeadlineStatusColorByDate(deadline)
}
